// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallEquipmentMaintenanceTaskType {
    CheckBox = 1,
    YesNo = 2,
    Text = 3,
    Numeric = 4,
}

export let nameof = "ServiceCallEquipmentMaintenanceTaskType";
